<template>
  <div>
    <div class="flex -ml-1 -mr-1">
      <button
        v-for="(variant,index) in variants"
        :key="index"
        @click.prevent="model = variant.id"
        :disabled="!variant.available"
        class="w-1/2 h-10 sm:h-12 border text-center mx-1 mb-1 text-sm hover:border-white focus:outline-none focus:shadow-outline select-none"
        :class="{ 'bg-white text-black border-white': model === variant.id, 'border-gray-300': model !== variant.id }">
        {{ variant.title }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variants: {
      type: Array,
      default () {
        return []
      }
    },

    value: {
      type: String,
      default: null
    },
  },

  computed: {
    model: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit("input", value)
      }
    }
  }
}
</script>
